import fileDefault from './../file.png'
import filePDF from './../PDF.png'
import filePNG from './../png.png'
import fileJPG from './../jpg.png'

export const ImageConfig = {
  default: fileDefault,
  pdf: filePDF,
  png: filePNG,
  jpg: fileJPG,
  jpeg: fileJPG
}
